import { jsonp, ajax } from '../../../../base/base';

const qqShareData = async () => {
    // api.3g.ifeng.com/weishare_token_api
    return await ajax('//api.cmpp.v.ifeng.com/api/SecertPost', {
        type: 'post',
        data: {
            url: window.location.href,
        },
    });
    // return await jsonp('//api.cmpp.v.ifeng.com/api/Secert', {
    //     data: {
    //         url: encodeURIComponent(window.location.href),
    //         _: '',
    //         rt: 'jsonp',
    //     },
    //     jsonpCallback: 'wxshareCallback',
    //     cache: false,
    // });
};

export { qqShareData };
